import { StrictModifierNames, Modifier } from 'react-popper'

type Modifiers = Array<Modifier<StrictModifierNames>>

export function buildModifiers(
  offset = 0,
  additionalModifiers?: Modifiers
): Modifiers {
  return [
    ...(additionalModifiers ? additionalModifiers : []),
    {
      name: 'computeStyles',
      enabled: true,
      options: {
        /**
         * GPU acceleration is set to false so that the top/left properties are used
         * instead of transforms.
         *
         * https://popper.js.org/docs/v2/modifiers/compute-styles/#gpuacceleration
         */
        gpuAcceleration: false
      }
    },
    {
      name: 'offset',
      enabled: true,
      // phase: 'write',
      options: {
        offset: [0, offset]
      }
    },
    {
      name: 'preventOverflow',
      enabled: false
    },
    {
      name: 'hide',
      enabled: false
    }
  ]
}
